import { html, ovl, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import { FileGet } from "../../../../../../../_ovlclient/src/global/globalapi"
import { D, T } from "../../../../../../../_ovlclient/src/global/globals"
import type { DownloadPopup } from "../../../parts/downloadpopup/downloadpopup"
import { FileType } from "../../../parts/filelist/filelist"

export class CompQuotationOverview extends SYSBaseElement {
  // handleFile(e: Event, fileName: string, fileType: FileType, docNum: string) {
  //   e.preventDefault()
  //   FileGet({
  //     ext: "",
  //     id1: fileName,
  //     cat: fileType,
  //     id2: docNum,
  //   })
  // }

  async getUI() {
    const handlePDFPopup = (e) => {
      if (!e.target.disabled) {
        e.stopPropagation()
        let id = e.target.getAttribute("aria-controls").replace("pQqQR214", "")
        if (
          this.state.app.screens.DATQuotation.quotationOverview
            .activeFilePopup === id
        ) {
          id = ""
        }
        this.actions.app.global.actions.TogglePDFPopup({
          key: id,
          obj: this.state.app.screens.DATQuotation.quotationOverview,
        })
      }
    }

    const handleRemoveAllPDFPopup = (e) => {
      this.actions.app.global.actions.TogglePDFPopup({
        key: "",
        obj: this.state.app.screens.DATQuotation.quotationOverview,
      })
    }

    let detailCount = Object.keys(
      this.state.app.screens.DATQuotation.quotationDetail.quotations
    ).length
    if (detailCount === 0) {
      return null
    }

    let statusColors = {
      Open: "ovl-quotationstatuscolor1",
      Closed: "ovl-quotationstatuscolor2",
      Canceled: "ovl-quotationstatuscolor3",
    }

    return html`
      <div class="ovl-smart-padding-lr-symmetrical ovl-smart-screen-margins">
        <div class="fd-layout-panel">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="sap-icon--sales-order sap-icon--xl ">
                ${T("DATDocumentDataQuotations")}
              </h3>
              <h4>
                ${T("DATDocumentDataQuotationListTitle", [
                  detailCount.toString(),
                ])}
              </h4>
              <p>
                (
                ${Object.keys(statusColors).map(
                  (k, i) => html`
                    <span class="${statusColors[k]}">
                      ${T("DATDocumentDataQuotationStatus" + k)}${Object.keys(
                        statusColors
                      ).length -
                        1 ===
                      i
                        ? ""
                        : ","}</span
                    >
                  `
                )}
                )
              </p>
            </div>
          </div>
          <div class="fd-layout-panel__body">
            <table class="fd-table">
              <thead class="fd-table__header">
                <tr class="fd-table__row">
                  <th class="fd-table__cell" width="2%" scope="col">
                    ${T("GENPDF")}
                  </th>
                  <th class="fd-table__cell" width="20%" scope="col">
                    ${T("GENNumber")}
                  </th>
                  <th class="fd-table__cell" width="53%" scope="col">
                    ${T("GENCommission")}
                  </th>
                  <th class="fd-table__cell" width="25%" scope="col">
                    ${T("GENDate")}
                  </th>
                </tr>
              </thead>
              <tbody class="fd-table__body">
                ${Object.keys(
                  this.state.app.screens.DATQuotation.quotationDetail.quotations
                )
                  .sort((a, b) => parseInt(b) - parseInt(a))
                  .map((k) => {
                    let o =
                      this.state.app.screens.DATQuotation.quotationDetail
                        .quotations[k]
                    let downloadPopup = html`<comp-downloadpopup
                      .props=${() => {
                        this.state.app.screens.DATQuotation.quotationDetail
                        return <DownloadPopup>{
                          activePopupKey:
                            this.state.app.screens.DATQuotation
                              .quotationOverview.activeFilePopup,
                          docNum: k,

                          documentDetailsState:
                            this.state.app.screens.DATQuotation.quotationDetail
                              .quotations,
                          documentScreensState:
                            this.state.app.screens.DATQuotation
                              .quotationOverview,

                          popupId: "ovlpdfpop1",
                          type: "Quotation",
                          onOpen: async () => {
                            await this.actions.app.screens.DATQuotation.actions.FetchQuotationDetail(
                              k
                            )
                          },
                        }
                      }}
                    >
                    </comp-downloadpopup>`

                    return html`
                      <tr class="fd-table__row ${statusColors[o.status]}">
                        <td class="fd-table__cell">${downloadPopup}</td>

                        <td class="fd-table__cell">${k}</td>
                        <td class="fd-table__cell">${o.refNum}</td>
                        <td class="fd-table__cell">${D(o.docDate)}</td>
                      </tr>
                    `
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `
  }
}
